import { render, staticRenderFns } from "./oridebaman.vue?vue&type=template&id=695b56ba&scoped=true&"
import script from "./oridebaman.vue?vue&type=script&lang=js&"
export * from "./oridebaman.vue?vue&type=script&lang=js&"
import style0 from "./oridebaman.vue?vue&type=style&index=0&id=695b56ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b56ba",
  null
  
)

export default component.exports